import { useEffect } from 'react';

// Loads the background logo from public/config.json at runtime, so the logo
// can be swapped per deployment (just edit/replace config.json on the server)
// without rebuilding the app. Cache-busted so a fresh image is fetched on
// every app start instead of an old cached one.
function useBackgroundLogo() {
  useEffect(() => {
    const cacheBuster = Date.now();

    fetch(`${process.env.PUBLIC_URL}/config.json?v=${cacheBuster}`, { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : null))
      .then((config) => {
        if (config?.backgroundLogoUrl) {
          const url = `${config.backgroundLogoUrl}${config.backgroundLogoUrl.includes('?') ? '&' : '?'}v=${cacheBuster}`;
          document.documentElement.style.setProperty('--app-bg-logo', `url("${url}")`);
        }
      })
      .catch(() => {
        // no config.json / offline: CSS fallback (--app-bg-logo: none) keeps the app usable
      });
  }, []);
}

export default useBackgroundLogo;
